import invariant from 'tiny-invariant'
import {
  MapDataFieldRefFormDataField,
  SubmitFormEntry,
} from '@chilipiper/api-client/src/chat-platform-chat'

/**
 * These dots helpers are needed because the backend expects to receive data field values with paths
 * like { 'Default.Person.PersonName': ... }, but final form uses dot notation as keyword to make
 * the values object deep nested object like { Default: { Person { ... } } }.
 */
export const removeDotsFromDataFieldPath = (path: string) => path.replace(/\./g, '_')
const addDotsOnDataFieldPath = (path: string) => path.replace(/_/g, '.')

export const parseValuesBeforeSubmitting = (
  values: Partial<Record<string, string>>,
  dataFields: Record<string, SubmitFormEntry>
) => {
  return Object.entries(values).reduce<MapDataFieldRefFormDataField>((acc, [nextKey, value]) => {
    const dottedKey = addDotsOnDataFieldPath(nextKey)
    const dataField = dataFields[dottedKey]
    invariant(dataField, `Data field ${dottedKey} not found`)
    const type = `${dataField.dataTypeInfo.type}Field` as const
    if (!value) {
      return acc
    }
    if (type === 'NumberField') {
      acc[dottedKey] = { value: parseInt(value), type }
    } else if (type === 'TrueFalseField') {
      acc[dottedKey] = { value: value === 'true', type }
    } else {
      acc[dottedKey] = {
        value,
        type: type === 'DateTimeField' || type === 'DateField' ? 'ShortTextField' : type,
      }
    }
    return acc
  }, {})
}

// Based on https://floatingapps.atlassian.net/wiki/spaces/CP/pages/954105869/Draft+Web+socket+communication.#Phone
export const phoneRegExp1 = /^(\+\d{1,3}( )?)?((\(\d{1,3}\))|\d{1,3})[- .]?\d{1,5}[- .]?\d{2,4}$/
export const phoneRegExp2 = /^(\+\d{1,3}( )?)?(\d{3}[ ]?){2}\d{1,3}$/
export const phoneRegExp3 = /^(\+\d{1,3}( )?)?(\d{3}[ ]?)(\d{2}[ ]?){2}\d{2}$/
export const phoneRegExp4 =
  /^(\+{1}(\d{1,3}[- .]{1}){1}|(\d{1,3}[- .]{1})){1}(\d{3}[- .]){2}(\d{2}[- .]){1}(\d{2})$/
export const phoneRegExp5 =
  /^(\+{1}(\d{1,3}[- .]{1}){1}){1}(\d{1}[- .]{1}){1}(\d{1,2}[- .]{1}){1}(\d{1,4}[- .]{1}){1}(\d{1,4})$/

const phoneRegExpsArray = [
  phoneRegExp1.source,
  phoneRegExp2.source,
  phoneRegExp3.source,
  phoneRegExp4.source,
  phoneRegExp5.source,
]

export const phoneRegExp = new RegExp('(' + phoneRegExpsArray.join(')|(') + ')')
